// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"fb0c661d","254":"5a515c8a","407":"278b2be0","412":"d5e3fc2e","419":"68deea06","572":"686056d8","763":"b31e30b7","970":"96cc063d"}[chunkId] + ".chunk.js";
};